<script>
	import { Button, Col, Row } from "sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import CPOProviderTable from "./CPOProviderTable.svelte";
	import { form, field } from "svelte-forms";
	import { onMount } from "svelte";
	import {
		loading,
		totalPages,
		loadingStatus,
		sizeSelect,
		initPage,
		errorMessage,
	} from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { required } from "svelte-forms/validators";
	import { extractErrorMessage } from "../../../../utils/misc";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let data = [];
	let dataList = [];

	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});

	$: queryParams = `?page=1&size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();

	let queryPage = searchParams.includes("page");

	$: if (queryPage) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
		initPage.set(+params.page);
	}
	$: if (!queryPage) {
		initPage.set(1);
	}

	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(`/v1/evCpoProvider${queryParams}`, {
				method: "GET",
				version: "evCharging",
			});

			data = res.data.data;
			dataList = res.data.data.dataList;
			totalPages.set(res.data.data.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
		}
	});

	const refreshData = async (type) => {
		try {
			if (type == "delete") {
				loading.set(true);
			} else {
				loadingStatus.set(true);
			}
			const res = await client(`/v1/evCpoProvider${queryParams}`, {
				method: "GET",
				version: "evCharging",
			});
			data = res.data.data;
			dataList = res.data.data.dataList;
			totalPages.set(res.data.data.totalPage);
			if (type == "delete") {
				loading.set(false);
			} else {
				loadingStatus.set(false);
			}
		} catch (err) {
			if (type == "delete") {
				loading.set(false);
			} else {
				loadingStatus.set(false);
			}
			extractErrorMessage(err);
		}
	};

	const cpoProvider = field("cpoProvider", "", [required()]);
	const myForm = form(cpoProvider);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/evCpoProvider", {
				method: "POST",
				version: "evCharging",
				data: {
					name: $cpoProvider.value,
				},
			});

			if (res.status === 200 && res.data.data.code === 0) {
				refreshData();
				loading.set(false);
			} else {
				loading.set(false);
				extractErrorMessage(
					`${res.data.data.code} : ${res.data.data.message}`
				);
			}

			load = false;
			loading.set(false);
		} catch (error) {
			console.log(error);
			load = false;
			loading.set(false);
		}
	};

	let idStatus;
	async function handleStatusChange(id, status) {
		idStatus = id;
		try {
			loadingStatus.set(true);
			const res = await client("/v1/evCpoProvider/status", {
				method: "PUT",
				version: "evCharging",
				data: {
					id,
					status: status ? 1 : 0,
				},
			});
			if (res.status === 200) {
				refreshData();
			}
		} catch (err) {
			extractErrorMessage(err);
			loadingStatus.set(false);
		}
	}
</script>

<Row>
	<ErrorMessageHandler message={$errorMessage} />
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="EV CPO Provider" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Add CPO Provider</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span> CPO Provider* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$cpoProvider.value}
						error={$myForm.hasError("cpoProvider.required")}
						errorText={$myForm.hasError("cpoProvider.required")
							? "CPO Provider is required"
							: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$cpoProvider.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								Add
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
	<Col class="d-flex justify-content-end" xs={6}>
		<div class="mx-4">
			<!-- <Button class="themeButton primary px-4" block>Import CSV</Button> -->
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<!-- <span on:click={handleDownloadCSV} class="link">
				<span class="link-text mt-2"> Download CSV Template </span>
			</span> -->
		</div>
	</Col>

	<Col class="my-5">
		<CPOProviderTable {data} {dataList} {handleStatusChange} {idStatus} />
	</Col>
</Row>
